import { useEffect } from 'react';

export default function ScrollToTop() {
  useEffect(() => {
    const handleScroll = () => {
      // Lille forsinkelse for at sikre, at DOM'en er opdateret før scroll
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
      }, 50);
    };
    
    window.addEventListener('popstate', handleScroll);
    
    const originalPushState = window.history.pushState;
    const originalReplaceState = window.history.replaceState;
    
    window.history.pushState = function(...args) {
      originalPushState.apply(this, args);
      handleScroll();
    };
    
    window.history.replaceState = function(...args) {
      originalReplaceState.apply(this, args);
      handleScroll();
    };
    
    // Scroll til toppen ved første indlæsning
    handleScroll();
    
    return () => {
      window.removeEventListener('popstate', handleScroll);
      window.history.pushState = originalPushState;
      window.history.replaceState = originalReplaceState;
    };
  }, []);
  
  return null;
}
